import { lazy } from 'react'
import locales from './locales'
import routes from './routes'
import themes from './themes'
import parseLanguages from 'base-shell/lib/utils/locale'
import grants from './grants'
import Loading from 'material-ui-shell/lib/components/Loading/Loading'
import getDefaultRoutes from './getDefaultRoutes'
import { defaultUserData, isGranted } from 'rmw-shell/lib/utils/auth'
import { getDatabase, ref, onValue, get, update, off } from 'firebase/database'

const config = {
  firebase: {
    prod: {
      initConfig: {
        apiKey: "AIzaSyAawQIhmU-FYlrrnvgcx1NrJX8Xzv1PdiY",
        authDomain: "cs-adria.firebaseapp.com",
        databaseURL: "https://cs-adria-default-rtdb.europe-west1.firebasedatabase.app",
        projectId: "cs-adria",
        storageBucket: "cs-adria.appspot.com",
        messagingSenderId: "478787724625",
        appId: "1:478787724625:web:35a02c55f89ced42175f70",
        measurementId: "G-YSSMTB2W45"
      },
      messaging: {
        publicVapidKey:
          'BD7cQM0GyjEm1Xp1PdPdoupouu3BcCr-c4QDGBwSqM42HM-GkCRjnF4bi7mZ7UxKHM9d1VDAiW-d1JkoXBDFuaA',
      },
    },
    dev: {
      initConfig: {
        apiKey: "AIzaSyAawQIhmU-FYlrrnvgcx1NrJX8Xzv1PdiY",
        authDomain: "cs-adria.firebaseapp.com",
        databaseURL: "https://cs-adria-default-rtdb.europe-west1.firebasedatabase.app",
        projectId: "cs-adria",
        storageBucket: "cs-adria.appspot.com",
        messagingSenderId: "478787724625",
        appId: "1:478787724625:web:35a02c55f89ced42175f70",
        measurementId: "G-YSSMTB2W45"
      },
      messaging: {
        publicVapidKey:
          'BD7cQM0GyjEm1Xp1PdPdoupouu3BcCr-c4QDGBwSqM42HM-GkCRjnF4bi7mZ7UxKHM9d1VDAiW-d1JkoXBDFuaA',
      },
    },
    devd: {
      initConfig: {
        apiKey: "AIzaSyAawQIhmU-FYlrrnvgcx1NrJX8Xzv1PdiY",
        authDomain: "cs-adria.firebaseapp.com",
        databaseURL: "https://cs-adria-default-rtdb.europe-west1.firebasedatabase.app",
        projectId: "cs-adria",
        storageBucket: "cs-adria.appspot.com",
        messagingSenderId: "478787724625",
        appId: "1:478787724625:web:35a02c55f89ced42175f70",
        measurementId: "G-YSSMTB2W45"
      },
      messaging: {
        publicVapidKey:
          'BD7cQM0GyjEm1Xp1PdPdoupouu3BcCr-c4QDGBwSqM42HM-GkCRjnF4bi7mZ7UxKHM9d1VDAiW-d1JkoXBDFuaA',
      },
    },
    firebaseuiProps: {
      signInOptions: [
        'google.com',
        // 'facebook.com',
        // 'twitter.com',
        // 'github.com',
        'password',
        // 'phone',
      ],
    },
  },
  googleMaps: {
    apiKey: 'AIzaSyByMSTTLt1Mf_4K1J9necAbw2NPDu2WD7g',
  },
  auth: {
    grants,
    redirectTo: '/dashboard',
    persistKey: 'base-shell:auth',
    signInURL: '/signin',
    onAuthStateChanged: async (user, auth) => {
      const db = getDatabase()

      try {
        if (user != null) {
          const grantsSnap = await get(ref(db, `user_grants/${user.uid}`))
          const notifcationsDisabledSnap = await get(
            ref(db, `disable_notifications/${user.uid}`)
          )

          const isAdminSnap = await get(ref(db, `admins/${user.uid}`))

          onValue(ref(db, `user_grants/${user.uid}`), (snap) => {
            auth.updateAuth({ grants: snap.val() })
          })
          onValue(ref(db, `disable_notifications/${user.uid}`), (snap) => {
            auth.updateAuth({ notificationsDisabled: !!snap.val() })
          })
          onValue(ref(db, `admins/${user.uid}`), (snap) => {
            auth.updateAuth({ isAdmin: !!snap.val() })
          })

          auth.updateAuth({
            ...defaultUserData(user),
            grants: grantsSnap.val(),
            notificationsDisabled: notifcationsDisabledSnap.val(),
            isAdmin: !!isAdminSnap.val(),
            isGranted,
          })

          update(ref(db, `users/${user.uid}`), {
            displayName: user.displayName,
            uid: user.uid,
            photoURL: user.photoURL,
            providers: user.providerData,
            emailVerified: user.emailVerified,
            isAnonymous: user.isAnonymous,
            notificationsDisabled: notifcationsDisabledSnap.val(),
          })

          update(ref(db, `user_chats/${user.uid}/public_chat`), {
            displayName: 'Public Chat',
            lastMessage: 'Group chat',
            path: `group_chat_messages/public_chat`,
          })
        } else {
          off(ref(db))

          auth.setAuth(defaultUserData(user))
        }
      } catch (error) {
        console.warn(error)
      }
    },
  },
  getDefaultRoutes,
  routes,
  locale: {
    locales,
    persistKey: 'base-shell:locale',
    defaultLocale: parseLanguages(['en', 'hr'], 'hr'),
    onError: (e) => {
      //console.warn(e)

      return
    },
  },
  menu: {
    MenuContent: lazy(() => import('../components/Menu/MenuContent')),
    MenuHeader: lazy(() =>
      import('material-ui-shell/lib/components/MenuHeader/MenuHeader')
    ),
  },
  theme: {
    themes,
    defaultThemeID: 'default',
    defaultType: 'light',
  },
  pages: {
    LandingPage: lazy(() => import('../pages/LandingPage')),
    PageNotFound: lazy(() => import('../pages/PageNotFound')),
  },
  components: {
    Menu: lazy(() => import('material-ui-shell/lib/containers/Menu/Menu')),
    Loading,
  },

  containers: {
    AppContainer: lazy(() =>
      import('material-ui-shell/lib/containers/AppContainer/AppContainer')
    ),
    LayoutContainer: lazy(() =>
      import('rmw-shell/lib/containers/LayoutContainer/LayoutContainer')
    ),
  },
}

export default config
